import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useParams} from '@github-ui/react-router'
import {ThreePanesLayout} from '@github-ui/three-panes-layout'

import {RepoIssuesSidebar} from '../components/sidebar/RepoIssuesSidebar'
import {useIssuesSidebarState} from '../hooks/use-issues-sidebar-state'

export function IssueViewsPage() {
  const {owner, repo} = useParams<{owner: string; repo: string}>()
  const {selectedLink, onSelectLink} = useIssuesSidebarState({
    owner: owner ?? '',
    repo: repo ?? '',
  })

  if (!isFeatureEnabled('issue_pinned_views') || !isFeatureEnabled('issue_pinned_views_index_page')) {
    return null
  }

  return (
    <ThreePanesLayout
      contentAs="div"
      resizeable={false}
      leftPaneWidth="medium"
      leftPane={{
        element: <RepoIssuesSidebar selectedLink={selectedLink} onSelectLink={onSelectLink} />,
        ariaLabel: 'Issues sidebar navigation',
      }}
      middlePane={<p>Views page</p>}
    />
  )
}
